// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, doc, getDoc, setDoc, addDoc, getDocs, updateDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD8oYzmYkNcfR3zogapQSGNk5EwQl_r6AI",
  authDomain: "sondosresto-6b686.firebaseapp.com",
  projectId: "sondosresto-6b686",
  storageBucket: "sondosresto-6b686.appspot.com",
  messagingSenderId: "408184687664",
  appId: "1:408184687664:web:e17532549e73fcfa53f1f5",
  measurementId: "G-EDQ4XHZWYM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const db = getFirestore(app);



 export { db, collection, doc, getDoc, setDoc, addDoc, getDocs, updateDoc };

// Export an object containing all necessary functions
// const firebaseFunctions = {
//     db,
//     collection,
//     doc,
//     getDoc,
//     setDoc,
//     addDoc
//   };
  
//   export default firebaseFunctions;